// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.colborneproject1__maintitle {
  padding-top: 4rem;
  font-size: 1.5rem;
  text-align: center;
  padding-bottom: 1.5rem;
}
@media (min-width: 768px) {
  .colborneproject1__imageparent {
    display: flex;
    flex-direction: column;
    margin: auto;
    justify-content: center;
    align-items: center;
  }
}
.colborneproject1__image--1, .colborneproject1__image--2, .colborneproject1__image--3, .colborneproject1__image--4, .colborneproject1__image--5, .colborneproject1__image--6, .colborneproject1__image--7, .colborneproject1__image--8, .colborneproject1__image--9, .colborneproject1__image--10, .colborneproject1__image--11, .colborneproject1__image--12, .colborneproject1__image--13, .colborneproject1__image--14 {
  display: block;
  margin: auto;
  width: 70vw;
  padding-bottom: 1rem;
}
@media (min-width: 768px) {
  .colborneproject1__image--1, .colborneproject1__image--2, .colborneproject1__image--3, .colborneproject1__image--4, .colborneproject1__image--5, .colborneproject1__image--6, .colborneproject1__image--7, .colborneproject1__image--8, .colborneproject1__image--9, .colborneproject1__image--10, .colborneproject1__image--11, .colborneproject1__image--12, .colborneproject1__image--13, .colborneproject1__image--14 {
    display: inline;
    width: 40vw;
    padding: 1rem 1rem;
  }
}
@media (min-width: 1280px) {
  .colborneproject1__image--1, .colborneproject1__image--2, .colborneproject1__image--3, .colborneproject1__image--4, .colborneproject1__image--5, .colborneproject1__image--6, .colborneproject1__image--7, .colborneproject1__image--8, .colborneproject1__image--9, .colborneproject1__image--10, .colborneproject1__image--11, .colborneproject1__image--12, .colborneproject1__image--13, .colborneproject1__image--14 {
    width: 30vw;
    height: 90vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/pages/ColborneOneProjPage/ColborneOneProjPage.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAjFI;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAoFR;AE3FI;EFSA;IAEQ,aAAA;IACA,sBAAA;IACA,YAAA;IACA,uBAAA;IACA,mBAAA;EAoFV;AACF;AAjFQ;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AAmFZ;AE1GI;EFmBI;IAMQ,eAAA;IACA,WAAA;IACA,kBAAA;EAqFd;AACF;AE5GI;EFcI;IAWQ,WAAA;IACA,YAAA;EAuFd;AACF","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.colborneproject1{\n    &__maintitle{\n        padding-top: 4rem;\n        font-size: 1.5rem;\n        text-align: center;\n        padding-bottom: 1.5rem;\n    }\n    &__imageparent{\n        @include tablet-and-desktop{\n            display: flex;\n            flex-direction: column;\n            margin: auto;\n            justify-content: center;\n            align-items: center;\n        }\n    }\n    &__image{\n        &--1, &--2, &--3, &--4, &--5, &--6, &--7, &--8, &--9, &--10, &--11, &--12, &--13, &--14{\n            display: block;\n            margin: auto;\n            width: 70vw;\n            padding-bottom: 1rem;\n            @include tablet-and-desktop{\n                display: inline;\n                width: 40vw;\n                padding: 1rem 1rem;\n            }\n            @include desktop{\n                width: 30vw; \n                height: 90vh;\n            }\n        }\n    }\n}\n","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
